import i18next from 'i18next';
import { SortOrder } from 'infrastructure/enums';

type Label = string | undefined | null;

export interface ISortOrderItem {
  id: SortOrder;
  name: string;
}

export const sortOrdersDataSource = (
  ascLabel?: Label,
  descLabel?: Label,
): ISortOrderItem[] => {
  return [
    {
      id: SortOrder.ASC,
      name: ascLabel ?? i18next.t('labels.atoz'),
    },
    {
      id: SortOrder.DESC,
      name: descLabel ?? i18next.t('labels.ztoa'),
    },
  ];
};
